/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';
import {editIcon, trashIcon, checkmarkIcon, deleteIcon} from '@deanone/dean-components';

Vue.use(Vuex, VueAxios, axios);

export const requestPartner = (context: any, partnerData: any) => {
  const url = '/-/trade/api/partner.info';

  return axios
    .post(url, {
      id: partnerData.id,
    });
};

export const requestPartnerAgreement = (context: any, partnerAgreementData: any) => {
  const url = '/-/trade/api/partner.agreement.info';

  return axios
    .post(url, {
      paid: partnerAgreementData.paid,
    });
};

export const processPartner = (context: any, partnerData: any) => {
  const url = '/-/trade/api/partner.save';

  return axios
    .post(url, partnerData);
};
